import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const getAuthHeaders = () => {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const AddLeadership = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    heading: '',
    title: '',
    description: '',
    image: null,
    status: 'active',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (e.target.type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files.length > 0 ? files[0] : null,
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.heading.trim()) {
      toast.error('Heading is required');
      return;
    }
    if (!formData.title.trim()) {
      toast.error('Title is required');
      return;
    }
    if (!formData.description.trim()) {
      toast.error('Description is required');
      return;
    }
    if (!formData.image) {
      toast.error('Image is required');
      return;
    }

    setLoading(true);

    const payload = new FormData();
    payload.append('heading', formData.heading.trim());
    payload.append('title', formData.title.trim());
    payload.append('description', formData.description.trim());
    payload.append('status', formData.status);
    payload.append('image', formData.image);

    try {
      const response = await postRequest('leadership', payload, getAuthHeaders());

      if (response?.data?.success) {
        toast.success('Leader created successfully');
        navigate('/leadership');
      } else {
        toast.error(response?.data?.message || 'Failed to create leader');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to create leader');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Add Leader</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-md-6 mt-2">
            <label htmlFor="heading" className="lables">Heading *</label>
            <input
              id="heading"
              name="heading"
              className="form-control"
              value={formData.heading}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="title" className="lables">Name *</label>
            <input
              id="title"
              name="title"
              className="form-control"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="image" className="lables">Image *</label>
            <input
              id="image"
              name="image"
              type="file"
              className="form-control-file"
              accept=".png,.jpg,.jpeg,.webp,.gif,.bmp,.svg,.avif,.tiff,.ico,.jfif,.pjpeg,.pjp,image/png,image/jpeg,image/jpg,image/webp,image/gif,image/bmp,image/svg+xml,image/avif,image/tiff,image/x-icon,image/jfif,image/*"
              onChange={handleChange}
              required
            />
            {formData.image && (
              <small className="text-muted d-block mt-1">Selected: {formData.image.name}</small>
            )}
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="status" className="lables">Status</label>
            <select
              id="status"
              name="status"
              className="form-control"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="col-12 mt-2">
            <label htmlFor="description" className="lables">Role *</label>
            <textarea
              id="description"
              name="description"
              rows="5"
              className="form-control"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Creating...' : 'Create Leader'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddLeadership;
